import {
  Building2,
  Plane,
  Route,
  Factory,
  Zap,
  TrainFront,
  Landmark,
} from "lucide-react";

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1760553120209-8e9d5d2493e3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBzbWFydCUyMGNpdHklMjBhZXJpYWx8ZW58MHx8fHwxNzg3ODEwOTY0fDA&ixlib=rb-4.1.0&q=85";

export const MARQUEE_ITEMS = [
  "Airport operational 2026",
  "109 km expressway spine",
  "₹91,000 Cr semicon fab",
  "920 sq km notified region",
  "5,000 MW solar park",
  "DMIC corridor node",
  "Plug-and-play trunk utilities",
  "6 town planning schemes",
];

export const ZONES = [
  { value: "TP 1", label: "TP 1 — Activation Area" },
  { value: "TP 2", label: "TP 2 — Linear Zone" },
  { value: "TP 3", label: "TP 3" },
  { value: "TP 4", label: "TP 4" },
  { value: "TP 5", label: "TP 5 — Industrial Linear" },
];

export const PROPERTY_TYPES = [
  "Residential Plot",
  "Commercial Land",
  "Industrial Plot",
  "NA Farm Plot",
];

export const INVESTOR_PROFILES = ["Individual", "NRI", "Institutional"];

export const COUNTRY_CODES = ["+91", "+971", "+1", "+44", "+65", "+61", "+81"];

export const PROPERTIES = [
  {
    id: "parcel-01",
    name: "Vertex Enclave",
    zone: "TP 1",
    zoneLabel: "Activation Area",
    sector: "2A",
    type: "Residential Plot",
    plotSqYd: 250,
    pricePerSqYd: 6800,
    reraStatus: "REGISTERED",
    reraId: "GJ-RERA/DHO/2024/0114",
    expresswayKm: 4,
    airportKm: 12,
    coords: "22.2487° N / 72.1952° E",
    image:
      "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBsdXh1cnklMjByZWFsJTIwZXN0YXRlJTIwYnVpbGRpbmd8ZW58MHx8fHwxNzg3ODEwOTY0fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "parcel-02",
    name: "Meridian Trade Quarter",
    zone: "TP 2",
    zoneLabel: "Linear Zone",
    sector: "7",
    type: "Commercial Land",
    plotSqYd: 1200,
    pricePerSqYd: 9500,
    reraStatus: "APPLIED",
    reraId: "GJ-RERA/DHO/2025/0291",
    expresswayKm: 2,
    airportKm: 9,
    coords: "22.2310° N / 72.2088° E",
    image:
      "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?auto=format&fit=crop&w=1200&q=70",
  },
  {
    id: "parcel-03",
    name: "Fab District 44",
    zone: "TP 4",
    zoneLabel: "Industrial Belt",
    sector: "11",
    type: "Industrial Plot",
    plotSqYd: 4000,
    pricePerSqYd: 4200,
    reraStatus: "REGISTERED",
    reraId: "GJ-RERA/DHO/2024/0177",
    expresswayKm: 6,
    airportKm: 18,
    coords: "22.1894° N / 72.2415° E",
    image:
      "https://images.unsplash.com/photo-1508916319692-80a99da75692?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwzfHxoaWdod2F5JTIwaW5mcmFzdHJ1Y3R1cmUlMjBhZXJpYWx8ZW58MHx8fHwxNzg3ODEwOTY0fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "parcel-04",
    name: "Canalfront Greens",
    zone: "TP 3",
    zoneLabel: "Canal Corridor",
    sector: "5B",
    type: "Residential Plot",
    plotSqYd: 400,
    pricePerSqYd: 5400,
    reraStatus: "REGISTERED",
    reraId: "GJ-RERA/DHO/2024/0203",
    expresswayKm: 5,
    airportKm: 14,
    coords: "22.2156° N / 72.1742° E",
    image:
      "https://images.unsplash.com/photo-1613977257363-707ba9348227?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBsdXh1cnklMjByZWFsJTIwZXN0YXRlJTIwYnVpbGRpbmd8ZW58MHx8fHwxNzg3ODEwOTY0fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "parcel-05",
    name: "Aeropolis Gateway",
    zone: "TP 2",
    zoneLabel: "Linear Zone",
    sector: "3",
    type: "Commercial Land",
    plotSqYd: 800,
    pricePerSqYd: 11200,
    reraStatus: "REGISTERED",
    reraId: "GJ-RERA/DHO/2025/0338",
    expresswayKm: 3,
    airportKm: 4,
    coords: "22.2389° N / 72.2201° E",
    image: HERO_IMAGE,
  },
  {
    id: "parcel-06",
    name: "Helios Industrial Reserve",
    zone: "TP 4",
    zoneLabel: "Industrial Belt",
    sector: "9",
    type: "Industrial Plot",
    plotSqYd: 6500,
    pricePerSqYd: 3900,
    reraStatus: "APPLIED",
    reraId: "GJ-RERA/DHO/2025/0355",
    expresswayKm: 8,
    airportKm: 22,
    coords: "22.1768° N / 72.2580° E",
    image:
      "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1200&q=70",
  },
  {
    id: "parcel-07",
    name: "Kamaatlav Airport Plot",
    zone: "TP 1",
    zoneLabel: "Airport Belt",
    sector: "16",
    surveyNo: "16",
    village: "Kamaatlav",
    roadWidth: "180 ft",
    landStatus: "Plan Pass · NA Ready",
    type: "Residential Plot",
    plotSqYd: 6910,
    pricePerSqYd: 8500,
    reraStatus: "APPLIED",
    reraId: "GJ-RERA/DHO/2026/0401",
    expresswayKm: 3,
    airportKm: 4,
    coords: "22.2205° N / 72.1840° E",
    isNew: true,
    image:
      "https://static.prod-images.emergentagent.com/jobs/e27e3fc3-f653-45f5-8491-446d4e394002/images/e082e81af90f9ed20940a85170eddfcb8fd935a79f93a103386f47275a2042fd.jpeg",
  },
  {
    id: "parcel-08",
    name: "Sandhida Industrial Linear",
    zone: "TP 5",
    zoneLabel: "Industrial Linear",
    sector: "586",
    surveyNo: "586",
    village: "Sandhida",
    roadWidth: "180 ft",
    landStatus: "Title Clear · NA Ready",
    type: "Industrial Plot",
    plotSqYd: 28548,
    pricePerSqYd: 15000,
    reraStatus: "APPLIED",
    reraId: "GJ-RERA/DHO/2026/0402",
    expresswayKm: 2,
    airportKm: 6,
    coords: "22.1602° N / 72.2470° E",
    isNew: true,
    image:
      "https://static.prod-images.emergentagent.com/jobs/e27e3fc3-f653-45f5-8491-446d4e394002/images/6b31c624f8dc7ba4495f86b1416acb344e67ed584596c98efdbe4312fadf5e1e.jpeg",
  },
  {
    id: "parcel-09",
    name: "Bavliyari Plot 312/7",
    zone: "TP 3",
    zoneLabel: "SIR Core",
    sector: "312/7",
    surveyNo: "312/7",
    village: "Bavliyari",
    roadWidth: "180 ft",
    landStatus: "Title Clear · NA Ready",
    type: "Residential Plot",
    plotSqYd: 4840,
    pricePerSqYd: 9000,
    reraStatus: "APPLIED",
    reraId: "GJ-RERA/DHO/2026/0403",
    expresswayKm: 4,
    airportKm: 5,
    coords: "22.1988° N / 72.2115° E",
    isNew: true,
    image:
      "https://static.prod-images.emergentagent.com/jobs/e27e3fc3-f653-45f5-8491-446d4e394002/images/aa55c99aa16b7da14252504e261232d81a1664c85de4fa12351a4696e0d764d9.jpeg",
  },
  {
    id: "parcel-10",
    name: "Bavliyari Estate 305",
    zone: "TP 3",
    zoneLabel: "SIR Core",
    sector: "305",
    surveyNo: "305",
    village: "Bavliyari",
    roadWidth: "180 ft",
    landStatus: "Title Clear · NA Ready",
    type: "Residential Plot",
    plotSqYd: 24200,
    pricePerSqYd: 9000,
    reraStatus: "APPLIED",
    reraId: "GJ-RERA/DHO/2026/0404",
    expresswayKm: 4,
    airportKm: 4,
    coords: "22.1975° N / 72.2140° E",
    isNew: true,
    image:
      "https://static.prod-images.emergentagent.com/jobs/e27e3fc3-f653-45f5-8491-446d4e394002/images/562327ce28dfa8c0c9a3b5c1f4d9bac4ad1c8b981394566232dc3520df4f2e4c.jpeg",
  },
  {
    id: "parcel-11",
    name: "Survey 305/P Farmland",
    zone: "TP 2",
    zoneLabel: "Developing Zone",
    sector: "305/P",
    surveyNo: "305/P",
    village: "Dholera SIR",
    roadWidth: "180 ft",
    landStatus: "NA Application in process",
    type: "NA Farm Plot",
    plotSqYd: 65000,
    pricePerSqYd: 3400,
    priceNote: "₹85 Lakh / Bigha · 26 Bigha",
    reraStatus: "APPLIED",
    reraId: "GJ-RERA/DHO/2026/0405",
    expresswayKm: 5,
    airportKm: 8,
    coords: "22.1880° N / 72.2260° E",
    isNew: true,
    image:
      "https://static.prod-images.emergentagent.com/jobs/e27e3fc3-f653-45f5-8491-446d4e394002/images/3cc62d0957e7b78ca527cb9a17317f8198b66dc75de8ccb6ed8793f38b05be2b.jpeg",
  },
];

export const MILESTONES = [
  {
    icon: Landmark,
    name: "ABCD Building & Command Centre",
    status: "Completed",
    progress: 100,
    note: "Administrative heart of the SIR — operational",
    detail:
      "The Administrative-cum-Business Centre for Dholera anchors city governance and houses the central command-and-control centre running all urban services.",
    target: "OPERATIONAL SINCE 2019",
  },
  {
    icon: Building2,
    name: "Trunk Infrastructure — TP 1 & TP 2",
    status: "Completed",
    progress: 100,
    note: "Roads, storm drains, ICT ducts & utilities laid",
    detail:
      "72 km of arterial roads with plug-and-play utility ducts across the Activation Area. Parcels are shovel-ready with power, water and data at the boundary.",
    target: "HANDED OVER 2023",
  },
  {
    icon: Route,
    name: "Ahmedabad–Dholera Expressway",
    status: "Under Construction",
    progress: 82,
    note: "109 km access-controlled spine",
    detail:
      "Four-lane greenfield expressway, expandable to eight, cutting Ahmedabad–Dholera travel to under an hour. Final surfacing and toll systems in progress.",
    target: "ACTIVATION 2025",
  },
  {
    icon: Plane,
    name: "Dholera International Airport",
    status: "Under Construction",
    progress: 64,
    note: "Greenfield · Phase 1 single runway",
    detail:
      "4,000 m runway with 20 MPPA ultimate capacity. Terminal structure topped out; airside pavement and navigation aids installation underway.",
    target: "OPERATIONAL 2026",
  },
  {
    icon: Zap,
    name: "5,000 MW Solar Park",
    status: "Under Construction",
    progress: 58,
    note: "300 MW already commissioned",
    detail:
      "One of the world's largest single-location solar parks. 300 MW is live and evacuating; the next 700 MW block is under erection.",
    target: "FULL CAPACITY 2030",
  },
  {
    icon: Factory,
    name: "Tata Semiconductor Fab",
    status: "Under Construction",
    progress: 41,
    note: "₹91,000 Cr anchor investment",
    detail:
      "India's first commercial semiconductor fab at 50,000 wafers per month capacity. Cleanroom structural works advancing on schedule in the industrial zone.",
    target: "PHASE 1 ROLLOUT 2026",
  },
  {
    icon: TrainFront,
    name: "Ahmedabad–Dholera Metro Link",
    status: "Upcoming",
    progress: 12,
    note: "DPR approved · alignment frozen",
    detail:
      "61 km regional rapid link connecting the airport, Activation Area and Ahmedabad. Land acquisition notifications issued along the corridor.",
    target: "SANCTION AWAITED · 2028 HORIZON",
  },
];
